import React from 'react'

function TechSCFClassic() {
  return (
    <embed src="\pdfs\E1.1.3_scf-classic_07.2013_kr.pdf" width="100%" height="2100px" />
  )
}

export default TechSCFClassic